import { AxiosResponse } from 'axios';
import { SET_LEAVE_TYPES, SET_LEAVE_TYPE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_LEAVE_TYPE_ISLOADING,
  DELETE_LEAVE_TYPE,
  EDIT_LEAVE_TYPE,
  GET_LEAVE_TYPES,
  GET_LEAVE_TYPE,
  REGISTER_LEAVE_TYPE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import LeaveType from '@/services/leave_type';
import { Module } from 'vuex';
import { EditLeaveType, RegisterLeaveType, GetLeaveType } from '@/dtos/leave_type.dto';

const leaveType: Module<any, {}> = {
  state: {
    leaveType: {
      data: null,
      isLoading: false,
    },
    leaveTypes: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    leaveType: (state: { leaveType: any }) => state.leaveType,
    leaveTypes: (state: { leaveTypes: any }) => state.leaveTypes,
  },
  mutations: {
    [SET_LEAVE_TYPE]: (
      state: { leaveType: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.leaveType.data = payload.data) : null,
        (state.leaveType.isLoading = payload.isLoading);
    },
    [SET_LEAVE_TYPES]: (
      state: { leaveTypes: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.leaveTypes.data = payload.data) : null,
        (state.leaveTypes.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_LEAVE_TYPE]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_TYPE, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveType.registerLeaveType(
        payload as RegisterLeaveType
      );

      if (result) {
        if (result.data.status) {
          commit(SET_LEAVE_TYPE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_TYPE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_TYPE, { isLoading: false });
        return false;
      }
    },
    [GET_LEAVE_TYPES]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_TYPES, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveType.getLeaveTypes(
        payload as GetLeaveType
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_TYPES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_TYPES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_TYPES, { isLoading: false });
        return false;
      }
    },
    [GET_LEAVE_TYPE]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_TYPES, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveType.getLeaveTypes(
        payload as GetLeaveType
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_TYPES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_TYPES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_TYPES, { isLoading: false });
        return false;
      }
    },
    [EDIT_LEAVE_TYPE]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_TYPE, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveType.editLeaveType(
        payload as EditLeaveType
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_TYPE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_TYPE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_TYPE, { isLoading: false });
        return false;
      }
    },
    [DELETE_LEAVE_TYPE]: async ({ commit }: any, payload: string) => {
      commit(SET_LEAVE_TYPE, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveType.deleteLeaveType(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_TYPE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_TYPE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_TYPE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_LEAVE_TYPE_ISLOADING]: ({ commit }) => {
      commit(SET_LEAVE_TYPE, { isLoading: false });
      commit(SET_LEAVE_TYPES, { isLoading: false });
    },
  },
};

export default leaveType;
